import { DEFAULT_INDEX_GROUP } from '@/constants/constants';
import type { SymbolKey } from '@/entities/symbol';

import type { ExportSymbolsPayload } from '../types/symbolTransform.types';

// Re-export types for backwards compatibility
export type {
  ExportIndexSymbol,
  ExportSymbolKey,
  ExportSymbolsPayload
} from '../types/symbolTransform.types';

export function transformSymbols(
  selectedSymbols: SymbolKey[],
  groupName: string = DEFAULT_INDEX_GROUP
): ExportSymbolsPayload {
  return {
    symbols: (selectedSymbols || []).map(symbol => ({
      group: groupName,
      key: {
        code: symbol.Code,
        periodType: symbol.PeriodType,
        timeRef: symbol.TimeRef,
        period: symbol.Period
      }
    }))
  };
}
